import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Seat, SeatsByRow, SeatsBySection } from '@core/models';
import {
  CartService,
  SelectedSeats,
  TutorialService,
  UtilitiesService,
} from '@core/services';
import { SeatManagementService } from '@features/digital-venue/services/seat-management.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
})
export class CartComponent implements OnInit, OnDestroy {
  // SERVICES
  private cartService: CartService = inject(CartService);
  private utilitiesService: UtilitiesService = inject(UtilitiesService);
  private seatManagementService: SeatManagementService = inject(
    SeatManagementService
  );
  private tutorialService = inject(TutorialService);

  // INPUT DATA
  @Input()
  public debugMode: boolean = false;

  @Input()
  public isTicketFeeEnabled: boolean = false;

  public subscriptions: Subscription[] = [];

  // STATE
  public cart: Subject<SelectedSeats> = this.cartService.selectedSeats$;
  public seatsBySection: SeatsBySection[] = [];

  // GETTERS
  public get hasItems(): boolean {
    return this.seatsBySection.length > 0;
  }

  // LIFE CYCLE
  public ngOnInit(): void {
    this.initComponent();
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  // METHODS
  public removeAllSeats(): void {
    this.seatManagementService.unselectAllSelectedSeats();
  }

  private initComponent(): void {
    const subscription1 =
      this.cartService.sortedSelectedSeatsBySectionArray$.subscribe({
        next: (response: SeatsBySection[]) => {
          // Formateamos la respuesta para añadir la distribución de las filas
          const sortedSeatsBySectionAndRowArray: SeatsBySection[] =
            this.utilitiesService.addRowDistribution(response);

          sortedSeatsBySectionAndRowArray.forEach((section: SeatsBySection) => {
            // Reasignamos los valores de los objetos a arrays para poder ordenarlos
            section.rows = Object.values(section.rows || []);
            // Ordenamos las filas por número de fila
            section.rows.forEach((row: SeatsByRow) => {
              row.seats = Object.values(row.seats).sort((a: Seat, b: Seat) => {
                return +a.seat! - +b.seat!;
              });
            });
          });

          // Asignamos el valor formateado y ordenado.
          this.seatsBySection = sortedSeatsBySectionAndRowArray;

          if (this.debugMode) {
            console.log('Seats By Section: ', this.seatsBySection);
          }
        },
        error: console.error,
      });
    this.subscriptions.push(subscription1);

    const subscription2 = this.tutorialService.tutorial$.subscribe({
      next: tutorial => {
        if (tutorial?.isOpen) {
          this.seatsBySection = this.tutorialService.getTutorialCart();
        } else {
          this.seatsBySection = [];
        }
      },
    });
    this.subscriptions.push(subscription2);
  }
}
